var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.109 17.2569L13.304 5.3159C12.7286 4.30616 11.273 4.30616 10.6976 5.3159L3.8926 17.2569C3.32273 18.2568 4.04487 19.4996 5.19583 19.4996H18.8058C19.9567 19.4996 20.6789 18.2568 20.109 17.2569ZM14.6072 4.57321C13.4564 2.55372 10.5452 2.55372 9.39433 4.57321L2.58937 16.5142C1.44963 18.5141 2.89391 20.9996 5.19583 20.9996H18.8058C21.1077 20.9996 22.552 18.5141 21.4122 16.5142L14.6072 4.57321Z",
    fill: "#2D3436",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z",
    fill: "#2D3436",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14.75C12.4142 14.75 12.75 14.4142 12.75 14V9.00001C12.75 8.5858 12.4142 8.25001 12 8.25001C11.5858 8.25001 11.25 8.5858 11.25 9.00001V14C11.25 14.4142 11.5858 14.75 12 14.75Z",
    fill: "#2D3436",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b78f9bec01fe7cfcae4ee36281b74f88.svg";
export { ForwardRef as ReactComponent };